/**
 * The lead's phone as the API expects it (55 + DDD + number), or null when the visitor left it blank.
 * The old inline `55${phone}` sent "55undefined" for an empty field and "5555…" when "+55" was typed.
 */
export function formatLeadPhone(raw?: string | null): string | null {
  let digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  return `55${digits}`;
}
